<template>
  <div class="form-input-group">
    <div class="label" v-if="label">{{ label }}</div>
    <div class="inputs">
      <slot />
    </div>
    <div class="error" v-if="$slots.error"><slot name="error" /></div>
  </div>
</template>

<script>
  export default {
    name: 'FormInputGroup',
    props: {
      label: {
        type: String,
        required: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .label {
    font-size: $inputLabelFontSize;
    color: $inputLabelColor;
    font-family: $inputFont;
    font-weight: 300;
    margin-bottom: $inputLabelFontSize;
  }

  .form-input-group {
    .inputs {
      display: flex;

      > label {
        margin-right: 3rem;
      }
    }
  }

  .error {
    color: $inputErrorColor;
    font-weight: bold;
    margin-top: 1rem;
  }
</style>
